/**
 * @flow
 * @relayHash 6d1423618ee0b4db9655b59b82454447
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type UserRoleLoaderFragment_viewer$ref = any;
export type UserRoleLoaderRefetchQueryVariables = {|
  first: number,
  offset: number,
  search: string,
|};
export type UserRoleLoaderRefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: UserRoleLoaderFragment_viewer$ref
  |}
|};
export type UserRoleLoaderRefetchQuery = {|
  variables: UserRoleLoaderRefetchQueryVariables,
  response: UserRoleLoaderRefetchQueryResponse,
|};
*/


/*
query UserRoleLoaderRefetchQuery(
  $first: Int!
  $offset: Int!
  $search: String!
) {
  viewer {
    ...UserRoleLoaderFragment_viewer_2pFftX
    id
  }
}

fragment UserRoleLoaderFragment_viewer_2pFftX on Query {
  userRoles(first: $first, offset: $offset, search: $search) {
    edges {
      node {
        id
        name
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UserRoleLoaderRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "UserRoleLoaderFragment_viewer",
            "args": (v1/*: any*/)
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "UserRoleLoaderRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "userRoles",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "UserRoleNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "UserRoleNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserRoleNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "UserRoleLoaderRefetchQuery",
    "id": null,
    "text": "query UserRoleLoaderRefetchQuery(\n  $first: Int!\n  $offset: Int!\n  $search: String!\n) {\n  viewer {\n    ...UserRoleLoaderFragment_viewer_2pFftX\n    id\n  }\n}\n\nfragment UserRoleLoaderFragment_viewer_2pFftX on Query {\n  userRoles(first: $first, offset: $offset, search: $search) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4758e54e8118d611109d79e8644ceef9';
module.exports = node;
